// src/pages/Dashboard/BookingsList.jsx
import React, { useMemo } from 'react';
import BookingCardComponent from '../BookingCardComponent';
import styled from 'styled-components';

const BookingsContainer = styled.div`
  margin-top: 16px;
`;

const BookingsList = ({ bookings = [], refreshBookings }) => {
  // Helper to format just the date (e.g., "Dec 19, 2024")
  const formatDateOnly = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Group bookings by date
  const bookingsByDate = useMemo(() => {
    const grouped = {};
    bookings.forEach((booking) => {
      const dateKey = formatDateOnly(booking.startTime);
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      grouped[dateKey].push(booking);
    });
    return grouped;
  }, [bookings]);

  return (
    <BookingsContainer>
      {Object.entries(bookingsByDate).map(([date, dateBookings]) => (
        <div key={date} style={{ marginBottom: 24 }}>
          <h3 style={{marginBottom: 10}}>{date}</h3>
          {dateBookings.map((booking) => (
            <BookingCardComponent
              key={booking._id}
              booking={booking}
              refreshBookings={refreshBookings}
            />
          ))}
        </div>
      ))}
    </BookingsContainer>
  );
};

export default BookingsList;
